import { getSet } from '../helpers/helpers';
import { JoiFile } from './files.model';
import { Ranking } from './events.data';

export type InformableType = "event" | "performer" | "performers" | "exhibitors" | "exhibitor" | 'resources' | 'resource' | 'attendee' | 'attendees'
export interface InformableTypes { event:InformableType, performer:InformableType, performers:InformableType, exhibitors: InformableType, exhibitor: InformableType, resource: InformableType, resources: InformableType, attendees: InformableType }
export const InformableTypes:InformableTypes = { event:'event', performer:'performer', performers:'performers', exhibitor: 'exhibitor', exhibitors: 'exhibitors', resource: 'resource', resources: 'resources', attendees: 'attendees' }


export interface InformableSectionItem {
  id: string
  name: string
  description: string
  placeholder: string
  files: JoiFile[]
  assetIds?: string[]
  assetItemTitle?: string // for display only, should not be saved
  section?: InformableSection  // for display only, should not be saved
  informable?: Informable  // for display only, should not be saved
}

export interface InformableSection { 
  id: string
  title: string
  placeholder?: string
  entityTypeIds?: string[]
  items: InformableSectionItem[]
}

export interface Informable {
  type: InformableType
  id?: string // this gets assigned on receive from db in era
  eventId: string
  performerId?: string
  exhibitorId?: string
  resourceId?: string
  attendeeId?: string
  info: InformableSection[]
  timestamp?: any
}

export const filterVisibleInformableSections = (info: InformableSection[]) => info || [] /*
  (info || []).map(section => ({ ...section, items: section.items.filter(item => item.description || item.files?.length ) }))
             .filter(s => s.items.length) */

export const filterVisibleEntityInformableSections = (info: InformableSection[], entityTypeId: string, activeTypes: Ranking[]) => {
  const activeIds = getSet(activeTypes, 'id')
  return filterVisibleInformableSections(info).filter(s => !s.entityTypeIds || !s.entityTypeIds.filter(id => activeIds.has(id)).length || s.entityTypeIds.includes(entityTypeId)) 
}


export interface InformableState {
  event: Informable
  performers: Informable
  exhibitors: Informable
  resources: Informable
  attendees: Informable
  attendee: {[resourceId:string]:Informable}
  resource: {[resourceId:string]:Informable}
  exhibitor: {[exhibitorId:string]:Informable}
  performer: {[performerId:string]:Informable}
}


export const informableStateCreator = ():InformableState => ({
  event: null,
  performers: null,
  exhibitors: null,
  resources: null,
  attendees: null,
  resource: {},
  performer:{},
  exhibitor:{},
  attendee:{}
})


export const makeDefaultEventInfo = (eventId): Informable => ({
  type:'event',
  eventId,
  info:[
  {id: 'Info-brief', title: 'Brief', items: [
    {id: 'default-1', name: 'Expected numbers', description: '', placeholder: 'Enter number', files: []},
    {id: 'default-2', name: 'Overview', description: '',  placeholder: 'Background to the event', files: []},
    {id: 'default-3', name: 'Objective', description: '', placeholder: 'Detail your event objective', files: []},
    {id: 'default-4', name: 'Audience Profile', description: '', placeholder: 'Age, experience, attitude to your objectives etc', files: []}
  ]}
]})

export const makeDefaultPerformersInfo = (eventId): Informable => ({
  type:'performers',
  eventId,
  info:[
    { id: 'Info-brief', title: 'General Information', items: [
        {id: 'default-1', name: 'Objective', description: '', placeholder: 'What is the business objective, what is it you want the audience to do as a result of the events', files: []},
        {id: 'default-2', name: 'Audience Profile', description: '', placeholder: 'Age, experience, attitude to your objectives etc', files: []},
      ]
    },
  ]
})

export const makeDefaultPerformerInfo = (eventId, performerId): Informable => ({
  type:'performer',
  eventId,
  performerId,
  info:[{ id: 'Info-brief', title: 'Specific Information', items: [] }]
})

export const makeDefaultAttendeesInfo = (eventId): Informable => ({
  type:'attendees',
  eventId,
  info:[
    { id: 'Info-brief', title: 'General Information', items: [
        {id: 'default-1', name: 'Event Overview', description: '', placeholder: 'Description of event', files: []},
        {id: 'default-2', name: 'Audience Profile', description: '', placeholder: 'Age, experience, attitude to your objectives etc', files: []},
      ]
    },
  ]
})

export const makeDefaultAttendeeInfo = (eventId, attendeeId): Informable => ({
  type:'attendee',
  eventId,
  attendeeId,
  info:[{ id: 'Info-brief', title: 'Specific Information', items: [] }]
})

export const makeDefaultExhibitorsInfo = (eventId): Informable => ({
  type:'exhibitors',
  eventId,
  info:[
    { id: 'Info-brief', title: 'General Information', items: [
        {id: 'default-1', name: 'Event Overview', description: '', placeholder: 'Description of event', files: []},
        {id: 'default-2', name: 'Audience Profile', description: '', placeholder: 'Age, experience, attitude to your objectives etc', files: []},
      ]
    },
  ]
})

export const makeDefaultExhibitorInfo = (eventId, exhibitorId): Informable => ({
  type: 'exhibitor',
  eventId,
  exhibitorId,
  info:[{ id: 'Info-brief', title: 'Specific Information', items: [] }]
})

export const makeDefaultResourcesInfo = (eventId): Informable => ({
  type:'resource',
  eventId,
  info:[
    { id: 'Info-brief', title: 'General Information', items: [
        {id: 'default-1', name: 'Event Overview', description: '', placeholder: 'Description of event', files: []},
        {id: 'default-2', name: 'Audience Profile', description: '', placeholder: 'Age, experience, attitude to your objectives etc', files: []},
      ]
    },
  ]
})

export const makeDefaultResourceInfo = (eventId, resourceId): Informable => ({
  type: 'resource',
  eventId,
  resourceId,
  info:[{ id: 'Info-brief', title: 'Specific Information', items: [] }]
})